module.exports = __webpack_public_path__ + "img/258804994.9fb7f528.jpg";